import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "vant/es/overlay/style";
import _Overlay from "vant/es/overlay";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
Vue.use(_Overlay);
export default {
  name: 'WishSuccess',
  components: {},
  props: {
    basic: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    successWishCitys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isShow: false,
      bgSrc: '',
      flSrc: '',
      boomSrc: '',
      allBlob: {
        bgBlob: '',
        flowerBlob: '',
        boomBlob: ''
      }
    };
  },
  watch: {
    'successWishCitys': {
      handler: function handler(val) {
        if (val && val.length && !this.isShow) {
          this.initGif();
        }
      }
    }
  },
  computed: {
    successWishCityText: function successWishCityText() {
      this.successWishCitys = this.successWishCitys.map(function (el) {
        return "".concat(el, "\u7AD9");
      });
      if (this.successWishCitys.length <= 2) {
        return this.successWishCitys.join('、');
      } else {
        var citys = this.successWishCitys.slice(0, 2);
        return "".concat(citys.join('、'), "...");
      }
    }
  },
  methods: {
    goToMusic: function goToMusic(e) {},
    getBlob: function getBlob(url) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fetch(url).then(function (response) {
                return response.blob();
              }).catch(function (err) {
                console.warn(err);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchImgBlob: function fetchImgBlob() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var srcMap, _yield$Promise$all, _yield$Promise$all2, bgBlob, flowerBlob, boomBlob;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              srcMap = {
                'bg': "https://p0.pipi.cn/mediaplus/fe_rock_web/cdf05c5c25c5c2d7e49a1343dda01771bddf5.png?imageMogr2/thumbnail",
                'flower': 'https://p0.pipi.cn/rock/prod/common/image/a5e069183cb25337fc15a551076f15a2.png?imageMogr2/thumbnail',
                'boom': 'https://p0.pipi.cn/mediaplus/fe_rock_web/cdf05c5c5bee328d3e4a180c192114fd7f76f.png?imageMogr2/thumbnail'
              };
              _context2.next = 3;
              return Promise.all([_this.getBlob(srcMap.bg), _this.getBlob(srcMap.flower), _this.getBlob(srcMap.boom)]);
            case 3:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              bgBlob = _yield$Promise$all2[0];
              flowerBlob = _yield$Promise$all2[1];
              boomBlob = _yield$Promise$all2[2];
              _this.allBlob = {
                bgBlob: bgBlob,
                flowerBlob: flowerBlob,
                boomBlob: boomBlob
              };
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    loadImage: function loadImage(src) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var newImage = new Image();
                newImage.src = src;
                newImage.onload = function () {
                  return resolve(src);
                };
                newImage.onerror = function () {
                  return reject(new Error("FAIled to load image at ".concat(url)));
                };
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    initGif: function initGif() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var newBgSrc, newFlSrc, newBoomSrc, _yield$Promise$all3, _yield$Promise$all4, bgSrc, flSrc, boomSrc;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!_this2.bgSrc) {
                _context4.next = 7;
                break;
              }
              URL.revokeObjectURL(_this2.allBlob.bgBlob);
              URL.revokeObjectURL(_this2.allBlob.flowerBlob);
              URL.revokeObjectURL(_this2.allBlob.boomBlob);
              _context4.next = 9;
              break;
            case 7:
              _context4.next = 9;
              return _this2.fetchImgBlob();
            case 9:
              _this2.isShow = true;
              newBgSrc = URL.createObjectURL(_this2.allBlob.bgBlob);
              newFlSrc = URL.createObjectURL(_this2.allBlob.flowerBlob);
              newBoomSrc = URL.createObjectURL(_this2.allBlob.boomBlob);
              _context4.next = 15;
              return Promise.all([_this2.loadImage(newBgSrc), _this2.loadImage(newFlSrc), _this2.loadImage(newBoomSrc)]);
            case 15:
              _yield$Promise$all3 = _context4.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
              bgSrc = _yield$Promise$all4[0];
              flSrc = _yield$Promise$all4[1];
              boomSrc = _yield$Promise$all4[2];
              _this2.bgSrc = bgSrc;
              _this2.boomSrc = boomSrc;
              setTimeout(function () {
                _this2.flSrc = flSrc;
              }, 467);
              _context4.next = 28;
              break;
            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](0);
              _this2.$owlReportError('艺人主页-强提醒动画error', _context4.t0);
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 25]]);
      }))();
    },
    onOk: function onOk() {
      this.isShow = false;
      this.flSrc = '';
      this.bgSrc = '';
      this.boomSrc = '';
      this.$emit('onOk');
    }
  }
};